'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState, useMemo } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';
import classNames from 'classnames';
import { debounce } from 'lodash';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import DesktopProductsHeader from 'components/consumer/category-page/components/DesktopProductsHeader';
import { ALGOLIA_INDEX_NAME, SORT_ORDER_TO_ALGOLIA_INDEX, DEFAULT_SORT_ORDER } from 'commons/constants';
import IconFilter from 'components/icons/iconFilter';
import { transformInspirationImageUrl } from 'components/consumer/inspiration-photos-grid/search-state/utils';
import CustomerNameWithEmoji from 'components/consumer/CustomerNameWithEmoji';
import useToggleIsSearchOpen from 'global-state/isSearchOpen/useToggleIsSearchOpen';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import DesktopProductListingSidebarContainer from 'components/consumer/ProductListingPage/components/desktop/DesktopProductListingSidebarContainer';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import JBSearchBox from 'components/consumer/consumer-search/components/JBSearchBox';
import { ResultHeaderSummary, productIndexes, CATEGORY_INDEX_MAPPING, ChangeToNextPopulatedIndex } from '../commons/helpers';
import MobileSearchFilters from './components/MobileSearchFilters';
import SearchDesktopSidebarHeader from './components/SearchDesktopSidebarHeader';
import SearchPagesContent from './components/SearchPagesContent';
import SearchCustomerPhotosContent from './components/SearchCustomerPhotosContent';
import SearchReviewsContent from './components/SearchReviewsContent';
import SearchProductsContent from './components/SearchProductsContent';
import removeQuickshipFacet from './helpers/removeQuickshipFacet';
import useSearchUrlQueryParams from './hooks/useSearchUrlQueryParams';
const ConsumerAdvancedSearchStatic = () => {
  const $ = _c(105);
  const isBrowser = useIsBrowser();
  const {
    queryUrlParam,
    categoryUrlParam,
    sortByUrlParam,
    updateUrlParam
  } = useSearchUrlQueryParams();
  const [sortOrder, setSortOrder] = useState(sortByUrlParam);
  const [activeSectionCount, setActiveSectionCount] = useState(null);
  const getIndexForCategoryAndSort = _temp;
  let t0;
  if ($[0] !== categoryUrlParam || $[1] !== sortByUrlParam) {
    t0 = getIndexForCategoryAndSort(categoryUrlParam, sortByUrlParam);
    $[0] = categoryUrlParam;
    $[1] = sortByUrlParam;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [algoliaIndexName, setAlgoliaIndexName] = useState(t0);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      configure: {
        facetFilters: "",
        facets: ["*"]
      },
      hitsPerPage: 12,
      page: 1
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [searchStateFiltersAndPage, setSearchStateFiltersAndPage] = useState(t1);
  const [searchStateQuery, updateSearchStateQuery] = useState(queryUrlParam);
  const [searchStateQueryVal, setSearchStateQueryVal] = useState(queryUrlParam);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = debounce(val => val && val?.length > 3 && setSearchStateQueryVal(val), 1000);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setSearchStateQueryValDebounced = t2;
  let t3;
  if ($[5] !== isBrowser || $[6] !== updateUrlParam) {
    t3 = updatedValue => {
      updateSearchStateQuery(updatedValue);
      if (!isNewConsumerApp || isBrowser) {
        if (updatedValue && updatedValue?.length > 3) {
          updateUrlParam({
            q: updatedValue
          });
        }
        setSearchStateQueryValDebounced(updatedValue);
      }
    };
    $[5] = isBrowser;
    $[6] = updateUrlParam;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setSearchStateQuery = t3;
  const [isDesktopFiltersOpen, setIsDesktopFiltersOpen] = useState(true);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      isHovered: false,
      hoveredOver: null
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const [hoveredValue, setHoveredValue] = useState(t4);
  const [expandableOpen, setExpandableOpen] = useState(false);
  const [inactive, setInactive] = useState(false);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [invalidProductIds, setInvalidProductIds] = useState(t5);
  let t6;
  if ($[10] !== searchStateFiltersAndPage) {
    t6 = searchStateFiltersAndPage || {};
    $[10] = searchStateFiltersAndPage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== searchStateQueryVal || $[13] !== t6) {
    t7 = {
      query: searchStateQueryVal,
      ...t6
    };
    $[12] = searchStateQueryVal;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const searchState = t7;
  let t8;
  if ($[15] !== searchState.configure?.facetFilters) {
    t8 = () => removeQuickshipFacet(searchState.configure?.facetFilters);
    $[15] = searchState.configure?.facetFilters;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  searchState.configure?.facetFilters;
  let t9;
  if ($[17] !== t8) {
    t9 = t8();
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const sanitizedCustomerPhotoFacetFilters = t9;
  let t10;
  bb0: {
    if (!searchState) {
      t10 = searchState;
      break bb0;
    }
    let t11;
    if ($[19] !== sanitizedCustomerPhotoFacetFilters || $[20] !== searchState.configure) {
      t11 = {
        ...searchState.configure,
        facetFilters: sanitizedCustomerPhotoFacetFilters
      };
      $[19] = sanitizedCustomerPhotoFacetFilters;
      $[20] = searchState.configure;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== searchState || $[23] !== t11) {
      t12 = {
        ...searchState,
        configure: t11
      };
      $[22] = searchState;
      $[23] = t11;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    t10 = t12;
  }
  const customerPhotosSearchState = t10;
  const toggleIsSearchOpen = useToggleIsSearchOpen();
  let t11;
  if ($[25] !== hoveredValue) {
    t11 = photoId => {
      const updatedHoveredValue = {
        ...hoveredValue
      };
      if (photoId === "out") {
        updatedHoveredValue.isHovered = false;
        updatedHoveredValue.hoveredOver = null;
      } else {
        updatedHoveredValue.isHovered = !hoveredValue.isHovered;
        updatedHoveredValue.hoveredOver = photoId;
      }
      setHoveredValue(updatedHoveredValue);
    };
    $[25] = hoveredValue;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const toggleReviewOnHover = t11;
  let t12;
  if ($[27] !== algoliaIndexName || $[28] !== searchStateFiltersAndPage || $[29] !== updateUrlParam) {
    t12 = newIndex => {
      const updatedSearchFiltersAndPage = {
        ...searchStateFiltersAndPage
      };
      updatedSearchFiltersAndPage.page = 1;
      const finalNewIndex = newIndex?.includes("price") || newIndex === ALGOLIA_INDEX_NAME.PRODUCTS ? newIndex : CATEGORY_INDEX_MAPPING[newIndex];
      if (newIndex !== algoliaIndexName) {
        setAlgoliaIndexName(finalNewIndex);
        updateUrlParam({
          category: finalNewIndex
        });
        setExpandableOpen(false);
        setSearchStateFiltersAndPage(updatedSearchFiltersAndPage);
      }
    };
    $[27] = algoliaIndexName;
    $[28] = searchStateFiltersAndPage;
    $[29] = updateUrlParam;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const onIndexChange = t12;
  let t13;
  if ($[31] !== categoryUrlParam || $[32] !== searchStateFiltersAndPage || $[33] !== updateUrlParam) {
    t13 = newSortOrder => {
      const updatedSearchFiltersAndPage_0 = {
        ...searchStateFiltersAndPage
      };
      updatedSearchFiltersAndPage_0.page = 1;
      setSortOrder(newSortOrder);
      const newIndex_0 = getIndexForCategoryAndSort(categoryUrlParam, newSortOrder);
      setAlgoliaIndexName(newIndex_0);
      if (newSortOrder === DEFAULT_SORT_ORDER) {
        updateUrlParam({
          sortBy: null
        });
      } else {
        updateUrlParam({
          sortBy: newSortOrder
        });
      }
      setSearchStateFiltersAndPage(updatedSearchFiltersAndPage_0);
    };
    $[31] = categoryUrlParam;
    $[32] = searchStateFiltersAndPage;
    $[33] = updateUrlParam;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const onSortOrderChange = t13;
  let t14;
  if ($[35] !== searchStateFiltersAndPage) {
    t14 = () => {
      const updatedSearchFiltersAndPage_1 = {
        ...searchStateFiltersAndPage
      };
      updatedSearchFiltersAndPage_1.page = updatedSearchFiltersAndPage_1.page + 1;
      setSearchStateFiltersAndPage(updatedSearchFiltersAndPage_1);
    };
    $[35] = searchStateFiltersAndPage;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  const updateSearchPage = t14;
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setSearchStateFiltersAndPage(_temp2);
    };
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const loadRest = t15;
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = (filterAndValue, isActive) => {
      setSearchStateFiltersAndPage(prevState => {
        setSearchStateFiltersAndPage(prev => {
          const existingFilters = prev.configure.facetFilters && typeof prev.configure.facetFilters === "string" ? [prev.configure.facetFilters] : prev.configure.facetFilters || [];
          if (isActive && existingFilters.includes(filterAndValue)) {
            return prevState;
          }
          return {
            ...prevState,
            configure: {
              ...prevState.configure,
              facetFilters: isActive ? [...existingFilters, filterAndValue] : existingFilters.filter(f => f !== filterAndValue)
            }
          };
        });
      });
    };
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const setActiveAlgoliaFilter = t16;
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => {
      setSearchStateFiltersAndPage(_temp3);
    };
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const resetAlgoliaFilters = t17;
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = shouldBeActive => {
      setSearchStateFiltersAndPage(prevState_1 => {
        setSearchStateFiltersAndPage(prev_0 => {
          const existingFilters_0 = prev_0.configure.facetFilters && typeof prev_0.configure.facetFilters === "string" ? [prev_0.configure.facetFilters] : prev_0.configure.facetFilters || [];
          return {
            ...prevState_1,
            configure: {
              ...prevState_1.configure,
              facetFilters: shouldBeActive ? [...existingFilters_0, "is_in_stock:true"] : existingFilters_0.filter(_temp4)
            }
          };
        });
      });
    };
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const handleToggleQuickshipFilter = t18;
  let t19;
  if ($[41] !== invalidProductIds) {
    t19 = productId => {
      if (!productId) {
        return;
      }
      if (!invalidProductIds?.includes(productId)) {
        setInvalidProductIds([...invalidProductIds, parseInt(productId, 10)]);
      }
    };
    $[41] = invalidProductIds;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const removeProductIdFromList = t19;
  let t20;
  if ($[43] !== invalidProductIds?.length) {
    t20 = updatedInvalidIds => {
      if (updatedInvalidIds?.length !== invalidProductIds?.length) {
        setInvalidProductIds(updatedInvalidIds);
      }
    };
    $[43] = invalidProductIds?.length;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const updateInvalidProductIds = t20;
  const getCustomProps = _temp6;
  let t21;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = classNames("relative mb-[100px] lg:z-[1001]", "[&_.ais-SearchBox-input]:pl-[30px] [&_.ais-SearchBox-input]:indent:[unset] [&_.ais-SearchBox-input]:text-left", "[&_.ais-SearchBox-input::placeholder]:text-left [&_.ais-SearchBox-input::placeholder]:indent:[unset]");
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["*"];
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Configure facets={t22} facetFilters="" numericFilters={["item_availability<2", "visibility>0", "visibility<4"]} />;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  const t24 = searchStateQuery || "";
  let t25;
  if ($[48] !== algoliaIndexName || $[49] !== queryUrlParam || $[50] !== setSearchStateQuery || $[51] !== t24 || $[52] !== toggleIsSearchOpen) {
    t25 = <div className="relative h-auto lg:!z-[1002]"><JBSearchBox defaultRefinement={t24} advanced={true} setInactive={setInactive} toggleSearchOpen={toggleIsSearchOpen} index={algoliaIndexName} initialQueryValue={queryUrlParam} setSearchStateQuery={setSearchStateQuery} /></div>;
    $[48] = algoliaIndexName;
    $[49] = queryUrlParam;
    $[50] = setSearchStateQuery;
    $[51] = t24;
    $[52] = toggleIsSearchOpen;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== activeSectionCount || $[55] !== algoliaIndexName || $[56] !== invalidProductIds || $[57] !== isDesktopFiltersOpen || $[58] !== searchState.query) {
    t26 = !productIndexes?.includes(algoliaIndexName) && !!searchState.query && <div className="pt-5"><DesktopProductsHeader><div className="flex"><ResultHeaderSummary invalidProductIds={invalidProductIds} indexName={algoliaIndexName} countOverride={activeSectionCount} queryOverride={searchState.query} /></div><div className="items-center flex flex-1 justify-end consumer-page__top-filters"><button type="button" className="text-base font-normal text-gray flex items-center justify-center relative mr-auto ml-4 w-[30px] h-[30px] rounded-[50%] bg-gray-light8 hover:cursor-pointer [&_svg]:relative [&_svg]:w-3 [&_svg]:h-38" onClick={() => {
            setIsDesktopFiltersOpen(!isDesktopFiltersOpen);
          }} aria-label="Toggle filters"><IconFilter /></button></div></DesktopProductsHeader></div>;
    $[54] = activeSectionCount;
    $[55] = algoliaIndexName;
    $[56] = invalidProductIds;
    $[57] = isDesktopFiltersOpen;
    $[58] = searchState.query;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== algoliaIndexName || $[61] !== onIndexChange) {
    t27 = <ChangeToNextPopulatedIndex currentIndex={algoliaIndexName} indexChange={onIndexChange} />;
    $[60] = algoliaIndexName;
    $[61] = onIndexChange;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== algoliaIndexName || $[64] !== expandableOpen || $[65] !== onIndexChange || $[66] !== searchState) {
    t28 = <MobileAndTabletOnly><MobileSearchFilters expandableOpen={expandableOpen} index={algoliaIndexName} onIndexChange={onIndexChange} searchState={searchState} setExpandableOpen={setExpandableOpen} /></MobileAndTabletOnly>;
    $[63] = algoliaIndexName;
    $[64] = expandableOpen;
    $[65] = onIndexChange;
    $[66] = searchState;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== algoliaIndexName || $[69] !== isDesktopFiltersOpen || $[70] !== onIndexChange || $[71] !== searchState) {
    t29 = !productIndexes?.includes(algoliaIndexName) && !!searchState.query && <DesktopOnly><div className="mt-2"><DesktopProductListingSidebarContainer isOpen={isDesktopFiltersOpen}><SearchDesktopSidebarHeader index={algoliaIndexName} onIndexChange={onIndexChange} searchState={searchState} /></DesktopProductListingSidebarContainer></div></DesktopOnly>;
    $[68] = algoliaIndexName;
    $[69] = isDesktopFiltersOpen;
    $[70] = onIndexChange;
    $[71] = searchState;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== activeSectionCount || $[74] !== algoliaIndexName || $[75] !== customerPhotosSearchState || $[76] !== hoveredValue || $[77] !== inactive || $[78] !== invalidProductIds || $[79] !== onIndexChange || $[80] !== onSortOrderChange || $[81] !== removeProductIdFromList || $[82] !== sanitizedCustomerPhotoFacetFilters || $[83] !== searchState || $[84] !== searchStateFiltersAndPage || $[85] !== searchStateQuery || $[86] !== sortOrder || $[87] !== toggleIsSearchOpen || $[88] !== toggleReviewOnHover || $[89] !== updateInvalidProductIds || $[90] !== updateSearchPage) {
    t30 = !!searchState.query && <div className="w-full mt-0 lg:mt-0"><div className="md:mx-[3.333vw] md:my-0 lg:w-full lg:m-0">{!productIndexes?.includes(algoliaIndexName) && <MobileAndTabletOnly><div className="lg:hidden"><ResultHeaderSummary countOverride={activeSectionCount} queryOverride={searchState.query} /></div></MobileAndTabletOnly>}{productIndexes?.includes(algoliaIndexName) && <SearchProductsContent hitsPerPage={searchStateFiltersAndPage.hitsPerPage} inactive={inactive} indexName={algoliaIndexName} invalidProductIds={invalidProductIds} loadRest={loadRest} onIndexChange={onIndexChange} onSortOrderChange={onSortOrderChange} onToggleQuickshipFilter={handleToggleQuickshipFilter} removeProductIdFromList={removeProductIdFromList} resetAlgoliaFilters={resetAlgoliaFilters} searchClient={searchClient} searchState={searchState} searchStateQuery={searchStateQuery} setActiveAlgoliaFilter={setActiveAlgoliaFilter} setInactive={setInactive} sortOrder={sortOrder} toggleIsSearchOpen={toggleIsSearchOpen} updateInvalidProductIds={updateInvalidProductIds} />}{algoliaIndexName === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS && <SearchCustomerPhotosContent facetFilters={sanitizedCustomerPhotoFacetFilters} getCustomProps={getCustomProps} hoveredValue={hoveredValue} indexName={algoliaIndexName} searchState={customerPhotosSearchState} searchStateQuery={searchStateQuery} toggleReviewOnHover={toggleReviewOnHover} updateSearchPage={updateSearchPage} onSectionCountChange={setActiveSectionCount} />}{algoliaIndexName === ALGOLIA_INDEX_NAME.REVIEWS && <SearchReviewsContent indexName={algoliaIndexName} searchClient={searchClient} searchState={searchState} searchStateQuery={searchStateQuery} updateSearchPage={updateSearchPage} onSectionCountChange={setActiveSectionCount} />}{algoliaIndexName === ALGOLIA_INDEX_NAME.STATIC_PAGES && <SearchPagesContent facetFilters={searchState.configure.facetFilters} indexName={algoliaIndexName} page={searchState.page} query={searchState.query} searchState={searchState} searchStateQuery={searchStateQuery} toggleIsSearchOpen={toggleIsSearchOpen} updateSearchPage={updateSearchPage} onSectionCountChange={setActiveSectionCount} />}</div></div>;
    $[73] = activeSectionCount;
    $[74] = algoliaIndexName;
    $[75] = customerPhotosSearchState;
    $[76] = hoveredValue;
    $[77] = inactive;
    $[78] = invalidProductIds;
    $[79] = onIndexChange;
    $[80] = onSortOrderChange;
    $[81] = removeProductIdFromList;
    $[82] = sanitizedCustomerPhotoFacetFilters;
    $[83] = searchState;
    $[84] = searchStateFiltersAndPage;
    $[85] = searchStateQuery;
    $[86] = sortOrder;
    $[87] = toggleIsSearchOpen;
    $[88] = toggleReviewOnHover;
    $[89] = updateInvalidProductIds;
    $[90] = updateSearchPage;
    $[91] = t30;
  } else {
    t30 = $[91];
  }
  let t31;
  if ($[92] !== t27 || $[93] !== t28 || $[94] !== t29 || $[95] !== t30) {
    t31 = <div className="mt-0 mx-0 mb-8 lg:mb-8 lg:flex">{t27}{t28}{t29}{t30}</div>;
    $[92] = t27;
    $[93] = t28;
    $[94] = t29;
    $[95] = t30;
    $[96] = t31;
  } else {
    t31 = $[96];
  }
  let t32;
  if ($[97] !== t26 || $[98] !== t31) {
    t32 = <FixedWidthContainer wide={true} noMobilePadding={true} noTabletPadding={true}>{t26}{t31}</FixedWidthContainer>;
    $[97] = t26;
    $[98] = t31;
    $[99] = t32;
  } else {
    t32 = $[99];
  }
  let t33;
  if ($[100] !== algoliaIndexName || $[101] !== searchState || $[102] !== t25 || $[103] !== t32) {
    t33 = <div className={t21}><InstantSearch searchClient={searchClient} indexName={algoliaIndexName} searchState={searchState}>{t23}{t25}{t32}</InstantSearch></div>;
    $[100] = algoliaIndexName;
    $[101] = searchState;
    $[102] = t25;
    $[103] = t32;
    $[104] = t33;
  } else {
    t33 = $[104];
  }
  return t33;
};
const ConsumerAdvancedSearchStaticWrapper = () => {
  const $ = _c(2);
  const isBrowser = useIsBrowser();
  if (!isNewConsumerApp || isBrowser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ConsumerAdvancedSearchStatic />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default ConsumerAdvancedSearchStaticWrapper;
function _temp(category, sort) {
  if (productIndexes?.includes(category) && sort && SORT_ORDER_TO_ALGOLIA_INDEX[sort]) {
    return SORT_ORDER_TO_ALGOLIA_INDEX[sort];
  }
  return category;
}
function _temp2(prevSearchFiltersAndPage) {
  return {
    ...prevSearchFiltersAndPage,
    hitsPerPage: 1000
  };
}
function _temp3(prevState_0) {
  return {
    ...prevState_0,
    configure: {
      ...prevState_0.configure,
      facetFilters: []
    }
  };
}
function _temp4(f_0) {
  return f_0 !== "is_in_stock:true";
}
function _temp5(p) {
  return p.upholstery;
}
function _temp6(selectedGridItem) {
  if (!selectedGridItem) {
    return {};
  }
  const customerName = `${selectedGridItem.customer_first_name} ${selectedGridItem.customer_last_name && selectedGridItem.customer_last_name[0]}.`;
  const products = selectedGridItem.products || [];
  return {
    imageProps: {
      src: transformInspirationImageUrl(selectedGridItem.image_link) || "",
      trim: "auto"
    },
    selectedItemName: <CustomerNameWithEmoji>{customerName}</CustomerNameWithEmoji>,
    selectedItemNameMobile: <span className="CustomerPhotosCustomerNameMobile">{customerName}</span>,
    selectedItemProducts: products,
    selectedItemMaterialList: products.map(_temp5),
    selectedItemDescription: selectedGridItem.photo_comment || "",
    showDescriptionQuoteMark: true
  };
}